module.exports = __webpack_public_path__ + "static/media/todolist.51ccb20d.png";